export default __webpack_public_path__ + "static/media/nuts_level_3.96b0e0da.geojson";